var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.27 3.01-.27.35-.71.9-.96 1.22-1.04 1.33-.94 1.2-.66.83-.17.22-.04.04-.1.13c-.05.09-.07.2-.07.3v3.8a5.85 5.85 0 0 0-.02-.05l.06-.14a.56.56 0 0 1-.05.1l.1-.13a.51.51 0 0 1-.08.08l.12-.1c-.1.08-.2.13-.3.18l-.64.37-1.43.81-.35.2.14-.06a5.46 5.46 0 0 1 .03 0 5.85 5.85 0 0 0 .11 0l.14.06a.25.25 0 0 1-.06-.03l.12.09a.42.42 0 0 1-.04-.04l.1.12a.28.28 0 0 1-.03-.04l.06.14a5.66 5.66 0 0 1 0 .1V9.52l-.02-.16c-.03-.1-.09-.17-.15-.26a.48.48 0 0 1-.03-.03l-.18-.23-.78-1L6 6.44l-1.18-1.5-.97-1.24-.51-.65L3.32 3a946.85 946.85 0 0 1 .05.04l.06.14a5.6 5.6 0 0 1 0-.04 5.6 5.6 0 0 0 0 .06l-.06.14a.49.49 0 0 1 .05-.09l-.09.12a.44.44 0 0 1 .06-.06l-.12.1a.51.51 0 0 1 .09-.06l-.14.06a5.6 5.6 0 0 1-.07 0h12.3a5.6 5.6 0 0 0-.07 0l-.14-.06a.4.4 0 0 1 .09.06l-.12-.1.06.06-.1-.12a.5.5 0 0 1 .06.09l-.06-.14.03.1a5.46 5.46 0 0 1-.02-.06 5.85 5.85 0 0 0-.01-.06l.06-.14a.43.43 0 0 1-.05.08c-.08.11-.1.32-.06.45a.58.58 0 0 0 .72.4.66.66 0 0 0 .35-.26.94.94 0 0 0-.21-1.27.97.97 0 0 0-.53-.2H3.24c-.17 0-.33.04-.48.1a.94.94 0 0 0-.5.8c-.02.11 0 .24.04.35.06.14.1.22.2.34l.25.32.62.79.85 1.08.95 1.2.9 1.15.74.93.42.55.06.07-.17-.42v5.43c.01.33.2.62.5.75.25.1.5.07.74-.06l.15-.09 1.42-.8 1.04-.6c.31-.19.5-.51.5-.88V9.51l-.16.42.47-.61 1.15-1.45L14.3 6.1l1.2-1.51.58-.75c.1-.13.18-.25.18-.42a.58.58 0 0 0-.58-.58c-.15 0-.33.05-.42.17Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.722410c0c88f824c170d88878d90fac7.svg";
export { ForwardRef as ReactComponent };